import { PdfStrings } from "../types";

export const sv: PdfStrings = {
  frontPage: {
    title: "Tack för förtroendet",
    description:
      "Arbetet med er utrustning är nu avslutat. Ni är alltid välkomna att kontakta oss vid frågor eller behov av vidare stöd.",
    didYouKnow: {
      title: "Visste du...",
      description: "...att vi även gör det här?\nMöt några av våra andra kunder:",
      link: {
        label: "avs.se/kundcase",
        url: "https://avs.se/kundcase",
      },
    },
    contactUs: {
      title: "Kontakta oss",
      description: "Har du frågor eller funderingar?\nKontakta oss:",
      url: "https://avs.se/kontakt",
    },
    missingSomething: {
      title: "Saknar du något?",
      description: "Saknar du någon utrustning?\nBesök vår webshop:",
      link: {
        label: "shop.avs.se",
        url: "https://shop.avs.se",
      },
    },
    serviceAndSupport: {
      title: "Service & Support",
      description: "Är det något som inte fungerar som förväntat:",
      url: "https://avs.se/service",
    },
  },
  orderPage: {
    reportTitle: "Slutrapport",
    orderSection: "Order",
    orderNumber: "Ordernr",
    customer: "Kund",
    address: "Adress",
    installations: "Installationer",
    serviceRequest: {
      title: "Felanmälan",
      createServiceRequest: "Skapa serviceärende via QR-koden eller",
      scanQrToSimplify: "För att förenkla ärendet - scanna QR-koden på din utrustning",
      clickHere: "klicka här",
      url: "https://avs.se/skapa-servicearende",
    },
    companyDescription:
      "AVS är en totalleverantör som levererar och installerar professionella AV-lösningar för mötesrum och arbetsplatser, med fokus på kvalitet, service och användarvänlighet.",
  },
  checklistPage: {
    installation: "Installation",
    selfInspection: "Egenkontroll",
    functionCheckDone: "Funktionskontroll utförd",
    documentationDone: "Dokumentation klar",
  },
  inspectionsSection: {
    title: "Slutbesiktning",
    withCustomerOnSite: "Slutbesiktning med kund på plats",
    withoutCustomerOnSite: "Slutbesiktning utan kund på plats",
    customerName: "Kundens namn",
    approvedInstallations: "Godkända installationer",
    personContacted: "Person som sökts",
    phone: "Telefon",
    time: "Tidpunkt",
    comment: "Kommentar",
  },
  productsSection: {
    title: "Produkter",
  },
  productDetails: {
    serialNumber: "Serienummer",
    macAddress: "MAC-adress",
    macAddressWifi: "MAC-adress (Wifi)",
    networkPort: "Nätverksuttag",
    assetNumber: "Asset-nummer",
    theftMarking: "Stöldmärkning",
    ipAddress: "IP-adress",
    username: "Användarnamn",
    password: "Lösenord",
    firmware: "Firmware",
    other: "Övrigt",
  },
  imagesSection: {
    title: "Bilder",
  },
  footer: {
    url: "https://www.avs.se",
  }
};
